import { render, staticRenderFns } from "./newSocket.vue?vue&type=template&id=7a3d2e28"
import script from "./newSocket.vue?vue&type=script&lang=js"
export * from "./newSocket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports